/* EXAMPLE USAGE
// Import the EventBus we just created.
import { EventBus } from './event-bus.js';

// The event handler function.
const clickHandler = function(clickCount) {
  console.log(`Oh, that's nice. It's gotten ${clickCount} clicks! :)`)
}

EventBus.$emit('i-got-clicked', this.clickCount);

// Listen to the event.
EventBus.$on('i-got-clicked', clickHandler);

// Stop listening.
EventBus.$off('i-got-clicked', clickHandler);

// For reuse of event
beforeDestroy: function () {
            EventBus.$off('toggleBurgerEvent');

        }

 */


import Vue from 'vue';
export const EventBus = new Vue();
